// Module
var code = "<div layout=\"column\" class=\"full-height\"> <bringoz-timeline-logs-table flex timeline=\"$ctrl.timeline\"></bringoz-timeline-logs-table> </div> ";
// Exports
export default code;